import React from 'react';
import {
  List,
  Datagrid,
  Responsive,
  TextInput,
  SimpleList,
  TopToolbar,
  DateField,
  SelectInput,
  ReferenceManyField,
  Pagination
} from 'react-admin';

import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import { makeStyles, Typography } from '@material-ui/core';
import CategoryTermsIcon from '@material-ui/icons/Description';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import { categoryTermStatus } from './CategoryTermsLookups';
import StatusSelectField from '../../core/components/StatusSelectField';
import PopupField from '../../core/components/grid/PopupField';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';

const useStyles = makeStyles({
  root: {
    marginRight: 'auto'
  },
  button: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    marginRight: '9px'
  },
  termNameFilterStyle: {
    minWidth: '200px'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const CategoryTermsFilter = props => {
  const classes = useStyles();
  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Category Term Name"
        source="title"
        alwaysOn
        options={{ autoComplete: 'off' }}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
        className={classes.termNameFilterStyle}
      />
      <SelectInput
        label="Status"
        source="status"
        choices={categoryTermStatus}
        allowEmpty
      />
    </Filter>
  );
};

const CategoryTermsName = props => {
  return (
    <ListTitleBar
      type="Category Terms"
      title="Create New Category Term"
      createUrl="#/categoryterms/create"
      icon={<CategoryTermsIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const CategoryField = props => {
  const { data } = props;
  const categories = data ? Object.values(data) : [];
  if (categories && categories.length > 1) {
    return (
      <div>
        <PopupField
          data={categories}
          label="Multiple Categories"
          headLabel="Category Name"
          optionText="categoryName"
        />
      </div>
    );
  } else if (categories && categories.length === 1) {
    return (
      <Typography variant="body2">{categories[0].categoryName}</Typography>
    );
  } else return <Typography variant="body2"> </Typography>;
};

const CategoryTermsList = props => {
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'title', order: 'ASC' }}
      exporter={false}
      title={<CategoryTermsName hasCreatePermission={hasCreatePermission} />}
      filters={<CategoryTermsFilter />}
      bulkActionButtons={false}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.title}
            secondaryText={record => record.status}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid>
            <LinkField source="title" label="Category Term Name" />
            <ReferenceManyField
              source="categoryTermId"
              target="categoryTermIds"
              reference="categorytermsrelations"
              link={false}
              label="Category Name"
              sortable={false}
              sort={{ field: 'categoryTermId', order: 'ASC' }}
              {...props}
            >
              <CategoryField {...props} label="Category" />
            </ReferenceManyField>
            <DateField label="Start Date" source="asOfDate" />
            <StatusSelectField
              label="Status"
              source="status"
              choices={categoryTermStatus}
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default CategoryTermsList;
